import(/* webpackMode: "eager" */ "/vercel/path0/src/app/error.tsx")